import { Injectable } from '@angular/core';
import { RegbpService } from '../api/src/app/services/regbp.service';
import { Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { Profile } from '..';

@Injectable({
  providedIn: 'root'
})
export class ProfileFacade {
  constructor(public regbpService: RegbpService) {}

  getProfile(): Observable<Profile> {
    return this.regbpService.getProfile().pipe(
      map((result: any) => result.value)
    );
  }

  updateProfile(profile: Profile): Observable<Profile> {
    return this.regbpService.updateProfile(profile).pipe(
      map((result: any) => result.$response.body.items[0]),
      catchError(err => {
        console.error('Handling error locally and rethrowing it...', err);
        return throwError(err);
      })
    );
  }

  formAccess(id: string, date: string): Observable<void> {
    return this.regbpService.formAccess(id, date).pipe(
      map((result: any) => result.$response.body),
      catchError(err => {
        console.error('Handling error locally and rethrowing it...', err);
        return throwError(err);
      })
    );
  }

}
